export default "__VITE_ASSET__$$hWXatx__"